import React, { useRef } from 'react';
import { FiUploadCloud } from 'react-icons/fi';

const FileUpload = ({ onChange, preview, accept = 'image/*' }) => {
  const inputRef = useRef(null);

  const handleClick = () => {
    inputRef.current?.click();
  };

  const handleChange = (e) => {
    const file = e.target.files?.[0];
    if (file) {
      onChange(file);
    }
  };

  return (
    <div>
      <div className="file-upload" onClick={handleClick}>
        <input
          ref={inputRef}
          type="file"
          accept={accept}
          onChange={handleChange}
          style={{ display: 'none' }}
        />
        <div className="file-upload-icon">
          <FiUploadCloud />
        </div>
        <p className="file-upload-text">
          <span>Click to upload</span> or drag and drop
        </p>
        <p style={{ fontSize: '12px', color: '#9ca3af', marginTop: '4px' }}>
          PNG, JPG, GIF up to 5MB
        </p>
      </div>
      {preview && (
        <img src={preview} alt="Preview" className="file-preview" />
      )}
    </div>
  );
};

export default FileUpload;
